import {
	CancelForRereservationFragment,
	CancelRereservationStatus,
} from "@/main/gql/__generated__/graphql"

export const canEdit = (
	rereservationStatus: CancelRereservationStatus
): boolean => {
	return rereservationStatus === "INFORMATION_NOT_ENOUGH"
}

export const rereservationStatusText: Record<
	CancelRereservationStatus,
	string
> = {
	ENCOURAGING_RERESERVATION_NOT_SCHEDULED: "未送付",
	ENCOURAGING_RERESERVATION_SCHEDULED: "送付予定",
	CANNOT_ENCOURAGE: "送付対象外",
	ENCOURAGING_MESSAGE_SENT: "送付済",
	RERESERVED: "再予約済",
	RERESERVATION_VISITED: "来店済",
	RERESERVATION_CANCELED: "キャンセル済",
	INFORMATION_NOT_ENOUGH: "送付情報不足",
	ENCOURAGING_MESSAGE_ABORTED: "送付停止",
	ENCOURAGING_MESSAGE_ABORTED_BY_RERESERVED: "他媒体で予約",

	// kokua
	RERESERVED_BY_REFUND_HUB: "再予約済",
	// RERESERVED_BY_OTHER_THAN_REFUND_HUB: "再予約済 (RefundHub以外)", # FIXME:
	RERESERVED_BY_OTHER_THAN_REFUND_HUB: "再予約済",
}

export const getSpanClass = (row: CancelForRereservationFragment, styles) => {
	let spanClass = ""
	if (
		row.rereservationStatus === "ENCOURAGING_RERESERVATION_NOT_SCHEDULED" ||
		row.rereservationStatus === "INFORMATION_NOT_ENOUGH"
	)
		spanClass = styles.background_light_orange
	else if (row.rereservationStatus === "ENCOURAGING_RERESERVATION_SCHEDULED")
		spanClass = styles.background_light_green
	else if (row.rereservationStatus === "ENCOURAGING_MESSAGE_SENT") {
		if (showClaimingConversionAppliedStatus(row)) {
			spanClass = styles.background_purple
		} else {
			spanClass = styles.background_pink
		}
	} else if (
		row.rereservationStatus === "RERESERVED_BY_REFUND_HUB" ||
		row.rereservationStatus === "RERESERVED_BY_OTHER_THAN_REFUND_HUB" ||
		row.rereservationStatus === "RERESERVED"
	) {
		spanClass = styles.background_blue
	} else if (row.rereservationStatus === "RERESERVATION_VISITED") {
		spanClass = styles.background_deep_blue
	} else if (
		row.rereservationStatus === "ENCOURAGING_MESSAGE_ABORTED_BY_RERESERVED"
	) {
		spanClass = styles.background_light_yellow
	} else if (
		row.rereservationStatus === "ENCOURAGING_MESSAGE_ABORTED" ||
		row.rereservationStatus === "RERESERVATION_CANCELED"
	) {
		spanClass = styles.background_red
	}

	return spanClass
}

export const formatMenusAndCoupons = (
	row: CancelForRereservationFragment
): string => {
	if (!row.rereservation) return ""

	const items = [
		...row.rereservation.menuNames.map((menu) => `・${menu}`),
		...row.rereservation.couponNames.map((coupon) => `・${coupon}`),
	]
	return items.join("\n")
}

export const claimingConversionExplainMessage =
	"5日以内に再予約されなければ、キャンセル料の請求を行う機能です。"

export const showClaimingConversionAppliedStatus = (
	row: CancelForRereservationFragment
): boolean => {
	return (
		row.rereservationStatus === "ENCOURAGING_MESSAGE_SENT" &&
		row.claimingConversionAppliedTime != null
	)
}

export const getStatusDisplayText = (
	row: CancelForRereservationFragment
): string => {
	if (showClaimingConversionAppliedStatus(row)) {
		return "請求転換済"
	}
	return rereservationStatusText[row.rereservationStatus]
}

// Rereservation.price は RefundHub 割引適用後の最終金額。discountPrice が割引額。
// 元金額 (店舗の成果額) = price + discountPrice。BE 契約が変わったらここを直す.
export type RereservationPriceFields = {
	price: number
	discountPrice: number | null
}

export const getRereservationOriginalPrice = (
	rereservation: RereservationPriceFields
): number => {
	return rereservation.price + (rereservation.discountPrice ?? 0)
}
